export default __webpack_public_path__ + "static/media/agregaciones.1a03e8e7.svg";